import _classCallCheck from "C:\\a\\2\\s\\Programs\\Microservices.Common.Frontend\\ecrion-components\\node_modules\\babel-preset-react-app\\node_modules\\@babel\\runtime/helpers/esm/classCallCheck";
import _createClass from "C:\\a\\2\\s\\Programs\\Microservices.Common.Frontend\\ecrion-components\\node_modules\\babel-preset-react-app\\node_modules\\@babel\\runtime/helpers/esm/createClass";
import _possibleConstructorReturn from "C:\\a\\2\\s\\Programs\\Microservices.Common.Frontend\\ecrion-components\\node_modules\\babel-preset-react-app\\node_modules\\@babel\\runtime/helpers/esm/possibleConstructorReturn";
import _getPrototypeOf from "C:\\a\\2\\s\\Programs\\Microservices.Common.Frontend\\ecrion-components\\node_modules\\babel-preset-react-app\\node_modules\\@babel\\runtime/helpers/esm/getPrototypeOf";
import _assertThisInitialized from "C:\\a\\2\\s\\Programs\\Microservices.Common.Frontend\\ecrion-components\\node_modules\\babel-preset-react-app\\node_modules\\@babel\\runtime/helpers/esm/assertThisInitialized";
import _inherits from "C:\\a\\2\\s\\Programs\\Microservices.Common.Frontend\\ecrion-components\\node_modules\\babel-preset-react-app\\node_modules\\@babel\\runtime/helpers/esm/inherits"; //@ts-check

import React, { Component } from 'react';
import getDataProps from '../../utils/propsUtil';
/**
 * @extends {React.Component<import('./types').CollapsibleProps> }
 */

var Collapsible =
/*#__PURE__*/
function (_Component) {
  _inherits(Collapsible, _Component);

  function Collapsible(props) {
    var _this;

    _classCallCheck(this, Collapsible);

    _this = _possibleConstructorReturn(this, _getPrototypeOf(Collapsible).call(this, props));
    _this.innerRef = React.createRef();
    _this.outerRef = React.createRef(); // Bind class methods

    _this.handleTriggerClick = _this.handleTriggerClick.bind(_assertThisInitialized(_this));
    _this.handleTransitionEnd = _this.handleTransitionEnd.bind(_assertThisInitialized(_this));
    _this.continueOpenCollapsible = _this.continueOpenCollapsible.bind(_assertThisInitialized(_this)); // Defaults the dropdown to be closed

    if (props.open) {
      _this.state = {
        isClosed: false,
        shouldSwitchAutoOnNextCycle: false,
        height: 'auto',
        transition: 'none',
        hasBeenOpened: true,
        overflow: props.overflowWhenOpen,
        inTransition: false
      };
    } else {
      _this.state = {
        isClosed: true,
        shouldSwitchAutoOnNextCycle: false,
        height: 0,
        transition: "height ".concat(props.transitionTime, "ms ").concat(props.easing),
        hasBeenOpened: false,
        overflow: 'hidden',
        inTransition: false
      };
    }

    return _this;
  }

  _createClass(Collapsible, [{
    key: "componentDidUpdate",
    value: function componentDidUpdate(prevProps, prevState) {
      var _this2 = this;

      if (this.state.shouldOpenOnNextCycle) this.continueOpenCollapsible();

      if (prevState.height === 'auto' && this.state.shouldSwitchAutoOnNextCycle === true) {
        window.setTimeout(function () {
          // Set small timeout to ensure a true re-render
          _this2.setState({
            height: 0,
            overflow: 'hidden',
            isClosed: true,
            shouldSwitchAutoOnNextCycle: false
          });
        }, 50);
      } // If there has been a change in the open prop (controlled by accordion)


      if (prevProps.open !== this.props.open) {
        if (this.props.open === true) {
          this.openCollapsible();
          this.props.onOpening();
        } else {
          this.closeCollapsible();
          this.props.onClosing();
        }
      }
    }
  }, {
    key: "closeCollapsible",
    value: function closeCollapsible() {
      this.setState({
        shouldSwitchAutoOnNextCycle: true,
        height: this.innerRef.current.offsetHeight,
        transition: "height ".concat(this.props.transitionTime, "ms ").concat(this.props.easing),
        inTransition: true
      });
    }
  }, {
    key: "openCollapsible",
    value: function openCollapsible() {
      this.setState({
        inTransition: true,
        shouldOpenOnNextCycle: true
      });
    }
  }, {
    key: "continueOpenCollapsible",
    value: function continueOpenCollapsible() {
      this.setState({
        height: this.innerRef.current.offsetHeight,
        transition: "height ".concat(this.props.transitionTime, "ms ").concat(this.props.easing),
        isClosed: false,
        hasBeenOpened: true,
        inTransition: true,
        shouldOpenOnNextCycle: false
      });
    }
  }, {
    key: "handleTriggerClick",
    value: function handleTriggerClick(event) {
      event.preventDefault();
      if (this.props.triggerDisabled) return;

      if (this.props.handleTriggerClick) {
        this.props.handleTriggerClick(this.props.accordionPosition);
      } else if (this.state.isClosed === true) {
        this.openCollapsible();
        this.props.onOpening();
      } else {
        this.closeCollapsible();
        this.props.onClosing();
      }
    }
  }, {
    key: "renderNonClickableTriggerElement",
    value: function renderNonClickableTriggerElement() {
      if (this.props.triggerSibling && typeof this.props.triggerSibling === 'string') {
        return React.createElement("span", {
          className: "".concat(this.props.classParentString, "__trigger-sibling")
        }, this.props.triggerSibling);
      } else if (this.props.triggerSibling) {
        return React.createElement(this.props.triggerSibling, null);
      }

      return null;
    }
  }, {
    key: "handleTransitionEnd",
    value: function handleTransitionEnd() {
      // Switch to height auto to make the container responsive
      if (!this.state.isClosed) {
        this.setState({
          height: 'auto',
          overflow: this.props.overflowWhenOpen,
          inTransition: false
        });
        this.props.onOpen();
      } else {
        this.setState({
          inTransition: false
        });
        this.props.onClose();
      }
    }
  }, {
    key: "render",
    value: function render() {
      var dropdownStyle = {
        height: this.state.height,
        WebkitTransition: this.state.transition,
        msTransition: this.state.transition,
        transition: this.state.transition,
        overflow: this.state.overflow
      };
      var openClass = this.state.isClosed ? 'is-closed' : 'is-open';
      var disabledClass = this.props.triggerDisabled ? 'is-disabled' : ''; //If user wants different text when tray is open

      var trigger = this.state.isClosed === false && this.props.triggerWhenOpen !== undefined ? this.props.triggerWhenOpen : this.props.trigger; // Don't render children until the first opening of the Collapsible if lazy rendering is enabled

      var children = this.props.lazyRender && !this.state.hasBeenOpened && this.state.isClosed && !this.state.inTransition ? null : this.props.children;
      if (children && typeof children === 'function') children = children(this.props); // Construct CSS classes strings

      var triggerClassString = "".concat(this.props.classParentString, "__trigger ").concat(openClass, " ").concat(disabledClass, " ").concat(this.state.isClosed ? this.props.triggerClassName : this.props.triggerOpenedClassName);
      var parentClassString = "".concat(this.props.classParentString, " ").concat(this.state.isClosed ? this.props.className : this.props.openedClassName);
      var outerClassString = "".concat(this.props.classParentString, "__contentOuter ").concat(this.props.contentOuterClassName);
      var innerClassString = "".concat(this.props.classParentString, "__contentInner ").concat(this.props.contentInnerClassName);
      return React.createElement("div", Object.assign({
        className: parentClassString.trim()
      }, getDataProps(this.props)), React.createElement("span", {
        className: triggerClassString.trim(),
        onClick: this.handleTriggerClick
      }, trigger), this.renderNonClickableTriggerElement(), React.createElement("div", {
        className: outerClassString.trim(),
        ref: this.outerRef,
        style: dropdownStyle,
        onTransitionEnd: this.handleTransitionEnd
      }, React.createElement("div", {
        className: innerClassString.trim(),
        ref: this.innerRef
      }, children)));
    }
  }]);

  return Collapsible;
}(Component);

Collapsible.defaultProps = {
  transitionTime: 50,
  easing: 'ease-in-out',
  open: false,
  classParentString: 'Collapsible',
  triggerDisabled: false,
  lazyRender: false,
  overflowWhenOpen: 'hidden',
  openedClassName: '',
  triggerClassName: '',
  triggerOpenedClassName: '',
  contentOuterClassName: '',
  contentInnerClassName: '',
  className: '',
  triggerSibling: null,
  onOpen: function onOpen() {},
  onClose: function onClose() {},
  onOpening: function onOpening() {},
  onClosing: function onClosing() {}
};
export default Collapsible;